import styled from 'styled-components';

export const UpperText = styled.span`
  text-transform: uppercase;
`;

export const TotalCount = styled.div`
  margin-left: 5px;
`;
